import { render, staticRenderFns } from "./Driver.vue?vue&type=template&id=315bb5dd&scoped=true&"
import script from "./Driver.vue?vue&type=script&lang=ts&"
export * from "./Driver.vue?vue&type=script&lang=ts&"
import style0 from "./Driver.vue?vue&type=style&index=0&id=315bb5dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315bb5dd",
  null
  
)

export default component.exports